const inStockCount = document.querySelector('.in-stock-count');
if (inStockCount) {
  let dnkTextCount = inStockCount.querySelector('.dnk-text-count');

  if (dnkTextCount) {
    const countMin = parseInt(dnkTextCount.getAttribute('data-count-min'), 10);
    const countCritical = parseInt(dnkTextCount.getAttribute('data-count-critical'), 10);
    const countMax = parseInt(dnkTextCount.getAttribute('data-count-max'), 10);
    let currentCount = countMax;
    if (localStorage.getItem('remainingTime')) {
      currentCount = parseInt(localStorage.getItem('remainingTime'));
    }
    const randMin = parseInt(dnkTextCount.getAttribute('data-rand-min'), 10);
    const randMax = parseInt(dnkTextCount.getAttribute('data-rand-max'), 10);
    const dnkTextContent = inStockCount.querySelector('.dnk-text-content');

    let beforeQuantity = dnkTextContent.textContent.split('[quantity]')[0];
    let afterQuantity = dnkTextContent.textContent.split('[quantity]')[1];
    dnkTextContent.innerHTML = beforeQuantity + dnkTextCount.outerHTML + afterQuantity;
    dnkTextCount.remove();
    dnkTextCount = inStockCount.querySelector('.dnk-text-count'); // dnkTextCount on new place
    let randomDelay = Math.floor(Math.random() * (randMax - randMin + 1)) + randMin;

    function countdownTimeout() {
      setTimeout(() => {
        startCountdown();
      }, randomDelay * 1000);
    }

    startCountdown();
    inStockCount.classList.remove("js");

    function startCountdown() {
      randomDelay = Math.floor(Math.random() * (randMax - randMin + 1)) + randMin;
      if (currentCount > countMin) {
        currentCount--;
        dnkTextCount.textContent = currentCount;
        localStorage.setItem('remainingTime', currentCount);
        countdownTimeout();
      } else {
        dnkTextCount.textContent = countMin;
      }
      if (currentCount <= countCritical) {
        inStockCount.classList.add('critical-count');
      }
    }
  }
}